import React from 'react';

import cn from 'classnames';

function CardGrid({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'au-card-grid au-grid au-grid-cols-1 md:au-grid-cols-2 lg:au-grid-cols-3 au-flex-wrap au-justify-center md:au-justify-start au-gap-c22 au-max-w-[1030px]',
        className
      )}
    >
      {children}
    </div>
  );
}

export default CardGrid;
